<template>
  <div class="clientNotification">
    <ListView
      class="table-primary-header"
      color="primary"
      @reload="reload"
      @create="actionCreate"
      :search.sync="search"
      :page.sync="page"
      :header="header"
      :data="data"
      show-select
      item-key="_id"
      :single-select="false"
      checkbox-color="primary"
      v-model="selectedNotifications"
    >
      <template v-slot:listHeader>
        <div class="d-flex align-center mb-8 flex-gap primary--text">
          <h3>Send Message</h3>
          <div class="flex-grow-1">
            <fletrix-text-field icon="mdi-magnify" v-model="search" placeholder="Search" />
          </div>
          <div style="width: 6rem">
            <v-select
              outlined
              hide-details="auto"
              dense
              label="Status"
              :items="statusOptions"
              v-model="statusFilterValue"
            ></v-select>
          </div>
          <v-btn
            @click="multipleSend"
            :disabled="selectedNotifications.length === 0"
            color="primary"
          >
            <v-icon>mdi-send</v-icon>
            Multiple Send
          </v-btn>
          <v-btn @click="actionCreate" color="primary">
            <v-icon>mdi-plus-thick</v-icon>
            Add New
          </v-btn>
        </div>
      </template>
      <template v-slot:item.to.phone="{ item }">
        {{ item.to.phone | displayPhone }}
      </template>
      <template v-slot:item.messageType="{ item }">
        {{ item.messageType | translateOptions(clientNotificationMessageTypeOption) }}
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip v-if="item.status === clientNotificationStatus.Pending" color="#DCEDC8" label>
          Draft
        </v-chip>
        <v-chip v-if="item.status === clientNotificationStatus.Sent" color="primary" label>
          Sent
        </v-chip>
      </template>

      <template v-slot:item.operation="{ item }">
        <div class="d-flex align-center justify-end flex-gap-sm">
          <v-btn
            @click.stop="copyItem(item)"
            depressed
            min-width="32px"
            width="32px"
            height="32px"
            min-height="32px"
          >
            <v-icon color="primary">mdi-content-copy</v-icon>
          </v-btn>
          <v-btn
            v-if="item.status === clientNotificationStatus.Sent"
            @click.stop="resend(item)"
            depressed
            min-width="32px"
            width="32px"
            height="32px"
            min-height="32px"
            color="primary"
          >
            <v-icon color="white">mdi-redo-variant</v-icon>
          </v-btn>
          <v-btn
            v-else
            @click.stop="actionDetails(item)"
            depressed
            min-width="32px"
            width="32px"
            height="32px"
            min-height="32px"
            color="primary"
          >
            <v-icon color="white">mdi-pencil</v-icon>
          </v-btn>

          <v-btn
            @click.stop="deleteItem(item)"
            depressed
            min-width="32px"
            width="32px"
            height="32px"
            min-height="32px"
          >
            <v-icon>mdi-trash-can</v-icon>
          </v-btn>
        </div>
      </template>
    </ListView>
    <ClientNotificationEditFormPopup
      v-model="isShowEditFormPopup"
      :id="clientNotificationId"
      :data="clientNotificationCopyData"
      @create="onItemCreate"
      @update="onItemUpdate"
    />
  </div>
</template>

<script>
import listViewPageMixin from '@/services/listViewPageMixin';
import ClientNotificationEditFormPopup from './ClientNotificationEditFormPopup.vue';
import { RESTFUL, roles, clientNotificationStatus } from '@/data/constants';
import { clientNotificationMessageTypeOption } from '@/data/optionsConstants';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { get } from 'lodash';
import api from '@/api';
import { crudDelete } from '@/api/crud';
//import { markClientNotificationShow } from '@/api/clientNotification';
import { getOid } from '@/services/utils';
import { FletrixTextField } from '@/components/Atom';
import { relatedAccountsPopulate } from '@/api/auth/membership';

export default {
  components: {
    ClientNotificationEditFormPopup,
    FletrixTextField,
  },
  mixins: [listViewPageMixin],
  data() {
    return {
      clientNotificationStatus,
      clientNotificationMessageTypeOption,
      header: [
        { text: 'Patient ID', value: 'to.sid' },
        { text: 'Patient Name', value: 'to.name' },
        { text: 'Mobile No.', value: 'to.phone' },
        { text: 'Message Type', value: 'messageType' },
        { text: 'Status', value: 'status' },
        { text: '', value: 'operation', width: '230px' },
      ],
      clientNotificationId: null,
      clientNotificationCopyData: null,
      isShowEditFormPopup: false,
      populate: [
        {
          path: 'to',
          populate: [
            relatedAccountsPopulate,
            {
              path: '_lastConsultation',
              select: ['_id', 'date', 'amount', 'hasFollowUp'],
            },
          ],
        },
        // { path: 'patient', select: ['_id', 'name', 'sid', 'phone', 'gender'] },
        // { path: 'consultation', select: ['_id', 'date'] },
      ],
      selectedNotifications: [],
      statusFilterValue: null,
    };
  },
  computed: {
    ...mapGetters('auth', ['profile', 'role']),
    restfulURL() {
      //TODO: by role
      return 'rml/admin/clientNotifications';
    },
    filter() {
      let filter = {};
      if (this.statusFilterValue) {
        filter['status'] = this.statusFilterValue;
      }
      return filter;
    },
    statusOptions() {
      return [
        {
          text: 'All',
          value: null,
        },
        {
          text: 'Draft',
          value: clientNotificationStatus.Pending,
        },
        {
          text: 'Sent',
          value: clientNotificationStatus.Sent,
        },
      ];
    },
  },
  watch: {
    data() {
      this.selectedNotifications = [];
    },
  },
  methods: {
    get,
    actionCreate() {
      this.clientNotificationCopyData = null;
      this.clientNotificationId = null;
      this.isShowEditFormPopup = true;
    },
    actionDetails(item) {
      this.clientNotificationCopyData = null;
      this.clientNotificationId = item._id;
      this.isShowEditFormPopup = true;
    },
    copyItem(item) {
      const { content, messageType, to } = item;
      this.clientNotificationCopyData = { content, messageType, to, _copyFrom: getOid(item) };
      this.clientNotificationId = null;
      this.isShowEditFormPopup = true;
    },
    async resend(item) {
      await this.$root.$confirm
        .open('Confirm to Send?', item.content, {
          color: 'primary',
          width: '30%',
        })
        .then(async confirm => {
          if (confirm) {
            await this.$store.dispatch('alert/closeAlert');
            (
              await api.post(`/rml/admin/clientNotification/send`, {
                ids: [getOid(item)],
              })
            ).data;
            await this.$store.dispatch('alert/updateAlertMessage', {
              msg: 'Sent',
              type: 'success',
              color: 'success',
            });
            this.reload();
          }
        });
    },
    deleteItem(item) {
      const title = 'Confirm';
      const message = `Do you confirm to delete?`;
      this.$root.$confirm.open(title, message, { color: 'red' }, 'Confirm').then(confirm => {
        if (confirm) {
          this.doDeleteItem(item._id);
        } else {
          return;
        }
      });
    },
    async doDeleteItem(id) {
      try {
        // this.clientProfile = {};
        await crudDelete(api, this.restfulURL, id);
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Deleted',
          type: 'success',
          color: 'success',
        });
        await this.reload();
      } catch (e) {
        console.log(e);
      }
    },
    onItemCreate(model) {
      this.isShowEditFormPopup = false;
      this.reload();
    },
    onItemUpdate(model) {
      this.isShowEditFormPopup = false;
      this.reload();
    },
    async changeShowStatus(model) {
      // await markClientNotificationShow(api, model._id, !model.isShow);
      // this.$set(model, 'isShow', !model.isShow);
    },
    navConsultation(consultation) {
      this.$router.push({ name: 'Consultation', params: { id: getOid(consultation) } });
    },
    async multipleSend() {
      const alertMessage = `${this.selectedNotifications.length} Message(s)`;
      await this.$root.$confirm
        .open('Confirm to Send?', alertMessage, {
          color: 'primary',
          width: '30%',
        })
        .then(async confirm => {
          if (confirm) {
            const ids = this.selectedNotifications.map(getOid);
            (
              await api.post(`/rml/admin/clientNotification/send`, {
                ids,
              })
            ).data;
            await this.$store.dispatch('alert/updateAlertMessage', {
              msg: 'Sent',
              type: 'success',
              color: 'success',
            });
            this.reload();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
// .clientNotification {
//   --v-primary-base: #ffb300;
// }
</style>
